import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderSuffering from "../../../../src/content/suffering-why-does-god-allow-it/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderSuffering,
  React
};